import { useLazyQuery, useMutation } from "@apollo/client";
import MiscellaneousModal from "@common/component/MiscellaneousModal";
import MultiSelectDropDownFilterV2 from "@common/component/MultiSelectDropDownFilterV2";
import MultiSelectNestedDropDown from "@common/component/MultiSelectNestedDropDown";
import { FontAwesome, Ionicons, MaterialIcons } from "@expo/vector-icons";
import EditIcon from "@mui/icons-material/Edit";
import Alert from "@mui/material/Alert";
import { IconButton, Snackbar } from "@mui/material";
import { PurchaserContext, PurchaserInterface } from "@src/context/PurchaserContext";
import { isAquaEnabled, isSpeedGaugeEnabled, minFormator, timeDifferenceInDayHrMin } from "@src/utils/functions";
import axios from "axios";
import moment from "moment";
import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { ActivityIndicator, Clipboard, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Button, Divider } from "react-native-elements";
import SearchBar from "react-native-elements/dist/searchbar/SearchBar-ios";
import { NavigationSwitchScreenProps } from "react-navigation";
import { HOST, REFURB_TOKEN, clientExternalV2, clientV2, makePostApiRequest } from "../../../../common";
import { CarCategory, CarDetailV3, InventoryTable, ModalV3, TooltipV3 } from "../../../../common/component";
import { customAxios, showAlert, workTypeColumn } from "../../../../common/helper";
import { FONT_FAMILY, THEME_COLORS } from "../../../../common/themes";
import PodAssignmentModal from "../PodAssignmentModal";
import STListing from "../STListing";
import { ASSIGN_NEXT_POD, ASSIGN_TECHNICIAN_TO_WORKSHOP_BAY } from "../mutations";
import {
  GET_ALL_POD_VERIFIERS,
  GET_ALL_WORKSHOP_POD_VERIFIERS,
  GET_JOB_CARD_FOR_USER_V2,
  GET_TECHNICIANS_FOR_CURRENT_POD,
  GET_WORKSHOP_BAY,
} from "../query";
import AppText from "@common/component/AppText";
import useButtonPress from "../../../../hooks/useButtonPress";

const getTimeDiff = (createdAtTime) => {
  var now = moment(new Date()); //todays date
  var end = moment(createdAtTime); // another date
  var duration = Math.round(moment.duration(now.diff(end)).asHours());

  const hrs = duration % 24;
  const hrString = hrs > 1 ? `${hrs}Hrs` : hrs == 1 ? "1Hr" : "30Min";
  return duration >= 24 ? `${Math.floor(duration / 24)}D ${hrs >= 1 ? hrString : ""}` : hrString;
  // return b.fromNow(true).replace('minutes', 'min').replace('days', 'D').replace('hours', 'H').replace('months', 'M');
};

interface JobCardListingV3Props extends NavigationSwitchScreenProps {
  search: string;
  setSearch: (search: string) => void;
}

interface FiltersType {
  data: {
    display_name: string;
    key: string;
    value: {
      display_name: string;
      key: string;
      nested_filters: {
        display_name: string;
        key: string;
      }[];
    }[];
  }[];
}

function JobCardListing(props: JobCardListingV3Props) {
  const { navigation, search, setSearch } = props;

  const { state: purchaserState, setMiscModal } = useContext<PurchaserInterface>(PurchaserContext);

  const [assignmentModal, setAssignModal] = useState<any>(null); // will contain refurbCarType
  const [podVerifierModal, setPodVerifierModal] = useState<any>(null);
  const [podVerifierSearch, setPodVerifierSearch] = useState("");
  const [selectedVerifier, setSelectedVerifier] = useState(null);
  const [verifierAssignLoading, setAssignVerifierLoading] = useState(false);
  const [verifierInitialLoading, setVerifierInitialLoading] = useState(false);
  const [podVerifierList, setPodVerifierList] = useState<any>({});
  const [verifierPage, setVerifierPage] = useState(1);
  const [stSearch, setStSearch] = useState("");
  const [selectedST, setST] = useState(null);
  const [page, setPage] = useState(1);
  const [orderBy, setOrderBy] = useState("");
  const [currentRow, setCurrentRow] = useState(null);
  const [refreshClick, setRefreshClick] = useState(false);
  const [filters, setFilters] = useState<any[]>([]);
  const [selectedJobListId, setSelectedJobListId] = useState(null);
  const [retry, setRetry] = useState(false);
  const timer = useRef(null);
  const [loading, setLoading] = useState(false);
  const [unholdLoading, setUnholdLoading] = useState<boolean>(false);
  const [holdReasons, setHoldReasons] = useState<{ id: string; name: string }[]>();
  const [breachedTat,setBreachedTat]=useState<boolean>(!!navigation?.state?.params?.breached_tat?.[0] ?? false);
  const [fetchedFilters, setFetchedFilters] = useState<FiltersType>({
    data: [],
  });

  const statusFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "status"),
    [fetchedFilters]
  );
  const procCatFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "proc_category"),
    [fetchedFilters]
  );
  const podFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "pod_value"),
    [fetchedFilters]
  );
  const podVerifierFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "pod_verifier"),
    [fetchedFilters]
  );
  const carGroupFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "group"),
    [fetchedFilters]
  );
  const technicianFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "technician"),
    [fetchedFilters]
  );
  const workTypeFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "work_type"),
    [fetchedFilters]
  );
  const remainingPodFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "remaining_pod"),
    [fetchedFilters]
  );
  const remainingPodCountFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "remaining_pod_count"),
    [fetchedFilters]
  );
  const i3CatFetchedFilters = useMemo(
    () => fetchedFilters?.data?.find?.((val) => val?.key === "i3_category"),
    [fetchedFilters]
  );
  const breachedTatToggle=useMemo(
    ()=>fetchedFilters?.data?.find?.((val) => val?.key === "breached_tat"),
    [fetchedFilters]
  )


  const [assignTechnician, { loading: loadingAssignment }] = useMutation(ASSIGN_TECHNICIAN_TO_WORKSHOP_BAY, {
    client: clientV2,
  });
  const cgtWorkshopMapping = useRef({});

  const [getRefurbCarListingV2, { data: listData, loading: listLoading, refetch: listRefetch, fetchMore }] =
    useLazyQuery(GET_JOB_CARD_FOR_USER_V2, {
      client: clientExternalV2,
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
    });
  const [getTechnicians, { data: technicianData, loading: techniciansLoading }] = useLazyQuery(
    GET_TECHNICIANS_FOR_CURRENT_POD,
    {
      client: clientV2,
      variables: {
        refurbCarId: "",
      },
      fetchPolicy: "network-only",
    }
  );

  const [getAllPodVerifiers] = useLazyQuery(GET_ALL_POD_VERIFIERS, {
    client: clientV2,
    variables: {
      refurbCarId: "",
      workshopId: "",
      page: 1,
    },
    fetchPolicy: "network-only",
  });
  const [getAllWorkshopPodVerifiers] = useLazyQuery(GET_ALL_WORKSHOP_POD_VERIFIERS, {
    client: clientV2,
    variables: {
      workshopId: localStorage.getItem("workshopId"),
    },
  });

  const [getWorkshopBay] = useLazyQuery(GET_WORKSHOP_BAY, { client: clientV2 });
  const [assignNextPOD] = useMutation(ASSIGN_NEXT_POD, {
    client: clientV2,
    fetchPolicy: "network-only",
  });

  window.onpopstate = () => {
    if (navigation?.state?.params?.comingFrom) navigation.navigate("WorkshopDashboard");
  };

  const refetchRefurbCarListingV2 = async (page?: number, filters?: any, search?: string, orderBy?: string) => {
    var filteredFilters = filters ?? [];
    const onlyListFilterValues = filteredFilters?.filter?.((val) => Array?.isArray(val?.value));
    onlyListFilterValues?.forEach((val) => {
      filteredFilters = filteredFilters?.filter?.((v) => v?.value !== val?.value);
      val?.value?.forEach?.((v) => {
        filteredFilters?.push?.({ key: val?.key, value: v });
      });
    });
    await listRefetch({ page, filters: filteredFilters, search, orderBy });
  };

  const getFiltersForWorkshopDashboard = async () => {
    try {
      const workshopId = localStorage.getItem("workshopId");
      const response = await customAxios?.({
        method: "GET",
        url: `${HOST}/external/get-filters-for-workshop-dashboard-listing/${workshopId}`,
        headers: {
          "Keycloak-Authorization": `Bearer ${localStorage?.getItem?.("token")}`,
          "auth-type": "Keycloak",
        },
      });
      setFetchedFilters({ data: response?.data?.data });
    } catch (e: any) {
      showAlert?.(e?.message ?? "Error: could not fetch filters for workshop dashboard", "error");
    }
  };

  const changeFilter = (key: string, value: string | string[]) => {
    // Remove previous filter keys
    const newFilters = filters.filter((obj) => obj.key !== key);
    if (value.length == 0) {
      setFilters(newFilters);
    } else {
      setFilters([...newFilters, { key, value }]);
    }
  };
  const changeToggleFilter = (key: string, value: string | string[]) => {
    const newFilters = [...filters]
    const index=filters.findIndex(obj => obj.key === key);
    if (index !== -1) {
      newFilters.splice(index, 1);
      setFilters(newFilters);
    } else {
      setFilters([...newFilters, { key, value }]);
    }
  };

  const onOpenSTListing = (row: any, ev: React.MouseEvent<HTMLElement>) => {
    // As the entire parent is clickable it stops event bubbling to parent
    ev.stopPropagation();

    getTechnicians({ variables: { refurbCarId: row?.id } });
    setAssignModal(row);
    const technicianDetails = {
      id: row?.currentPodTechnicianNameAndAssignTime?.[2]?.label,
      fullName: row?.currentPodTechnicianNameAndAssignTime?.[0]?.label,
    };
    if (technicianDetails) setST(technicianDetails);
  };

  const onOpenVerifierListing = (row: any, ev: React.MouseEvent<HTMLElement>) => {
    // As the entire parent is clickable it stops event bubbling to parent
    ev.stopPropagation();
    let { currentPodVerifierName, currentPodVerifierId } = row?.podVerifierData;

    setVerifierInitialLoading(true);
    getAllPodVerifiers({
      variables: {
        refurbCarId: row?.id,
        workshopId: localStorage.getItem("workshopId"),
        page: 1,
      },
    })
      .then((resp) => {
        setVerifierInitialLoading(false);
        setPodVerifierList(resp?.data?.getAllPodVerifiers);
      })
      .catch(() => setVerifierInitialLoading(false));

    setPodVerifierModal(row);
    const verifierDetails = {
      userId: currentPodVerifierId,
      fullName: currentPodVerifierName,
    };
    if (currentPodVerifierName) setSelectedVerifier(verifierDetails);
  };

  const getPodVerifierPagination = (text = search) => {
    setVerifierPage(verifierPage + 1);
    getAllPodVerifiers({
      variables: {
        refurbCarId: podVerifierModal?.id,
        workshopId: localStorage.getItem("workshopId"),
        page: verifierPage + 1,
      },
    }).then((resp) => {
      let verifierData = resp?.data?.getAllPodVerifiers;
      setPodVerifierList({
        data: [...podVerifierList?.data, ...verifierData?.data],
        paginator: { ...verifierData?.paginator },
      });
    });
  };

  const unHoldJobList = async (jobListId: string) => {
    setUnholdLoading(true);
    
    try {
      const response = await axios?.post?.(
        `${HOST}/joblist/un-hold`,
        {
          job_list_id: jobListId,
        },
        {
          headers: {
            "Keycloak-Authorization": `Bearer ${localStorage?.getItem?.("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data?.success) {
        showAlert?.(response?.data?.message, "success");
        await refetchRefurbCarListingV2?.(page, filters, search, orderBy);
      } else {
        throw Error(response?.data?.message ?? "Unsuccessful response from unhold API");
      }
    } catch (e) {
      showAlert?.(e?.response?.data?.message ?? "Could not unhold the joblist", "error");
    } finally {
      setUnholdLoading(false);
    }
  };

  const unHoldJobListBtnSingleClick = useButtonPress(unHoldJobList)
  useEffect(() => {
    var filteredFilters = filters ?? [];
    const onlyListFilterValues = filteredFilters?.filter?.((val) => Array?.isArray(val?.value));
    onlyListFilterValues?.forEach((val) => {
      filteredFilters = filteredFilters?.filter?.((v) => v?.value !== val?.value);
      val?.value?.forEach?.((v) => {
        filteredFilters?.push?.({ key: val?.key, value: v });
      });
    });
    if (!!listData) refetchRefurbCarListingV2?.(page, filters, search, orderBy);
  }, [filters, orderBy, search]);

  useEffect(() => {
    if (refreshClick) onRefreshClick(currentRow);
  }, [refreshClick]);

  const onClickSort = useCallback((key: any) => {
    setOrderBy((orderBy) => (orderBy === key ? "" : key));
  }, []);

  const onRefreshClick = useCallback(
    async (row) => {
      try {
        setLoading(true);
        await assignNextPOD({ variables: { jobListId: row?.jobList?.id } });
        await refetchRefurbCarListingV2?.(page, filters, search, orderBy);
        setLoading(false);
        setRefreshClick(false);
        setCurrentRow(null);
      } catch (e) {
        setLoading(false);
        setRefreshClick(false);
        setCurrentRow(null);
      }
    },
    [refreshClick]
  );

  const copyLeadIdOnPress = (text: string) => {
    Clipboard.setString(text);
  };

  const columnData = useMemo(
    () => [
      {
        name: "Work & Lead ID",
        label: "lead_id",
        component: ({ row }: any) => {
          return (
            <View>
              <Text style={styles.workLeadId}>{workTypeColumn[row?.refurbCategory] ?? "N/A"}</Text>
              <TouchableOpacity
                style={{ flexDirection: "row", alignItems: "center" }}
                onPress={() => {
                  copyLeadIdOnPress(row?.car?.objectId ?? row?.orderId);
                }}
              >
                <Text style={[styles.workLeadId, { marginEnd: 5, color: THEME_COLORS.textGrey }]}>
                  {row?.car?.objectId ?? row?.orderId}
                </Text>
                <MaterialIcons name="content-copy" size={16} color={THEME_COLORS.purple} />
              </TouchableOpacity>
            </View>
          );
        },
        width: "10%",
      },
      {
        name: "CAR",
        component: ({ row }: any) => (
          <CarDetailV3 carObject={{ ...row.car, year: row.car.year.slice(2) }} fontFamily={FONT_FAMILY.primaryV3} isCopyToClipboardEnabled/>
        ),
        width: "13%",
      },
      {
        name: "Category",
        label: "car.procCategory",
        component: ({ row }: any) => {
          return <CarCategory procCategory={row.car?.procCategory} i3Category={row.jobList?.inspectionStatus} />;
        },
        width: "3%",
      },
      {
        name: "Time in WS",
        label: "createdAt",
        component: ({ row }: any) => {
          return (
            <View>
              <Text style={{ fontFamily: FONT_FAMILY.semiBoldV3 }}>{getTimeDiff(row.createdAt)}</Text>
              <Text>{moment(row.createdAt).format("DD MMM 'YY hh:mmA")}</Text>
            </View>
          );
        },
        sortable: true,
        onSort: () => {
          onClickSort("created_at");
        },
        width: "13%",
      },
      {
        name: "CGT",
        label: "assignedCgt.fullName",
        width: "10%",
        component: ({ row }: any) => {
          return (
            <View>
              <AppText numberOfLines={2} fontFamily='medium' fontSize={13} color={THEME_COLORS.coal}>{row?.assignedCgt?.fullName}</AppText>
            </View>
          );
        },
      },
      {
        name: "POD",
        component: ({ row }: any) => {
          const statusExtractor = row?.isBayLayoutEnabled ? "jobCardStatus" : "sansPodJobCardStatus";
          const status_display =
            isAquaEnabled() && row?.isBayLayoutEnabled ? (
              [
                <Text
                  style={[
                    styles.status,
                    {
                      color: row?.jobList?.jobCardStatus?.[0]?.color,
                      fontFamily: FONT_FAMILY.primaryV3,
                      WebkitLineClamp: 2,
                    },
                  ]}
                >
                  {row?.workshopRefurbCarPodAndStatus?.podName ?? ""}
                </Text>,
              ]
            ) : Array.isArray(row?.jobList?.[statusExtractor]) ? (
              row?.jobList?.[statusExtractor].slice(0, 1)?.map((item, index) => {
                return (
                  <Text
                    key={index.toString()}
                    style={[
                      styles.status,
                      {
                        color: item?.color,
                        fontFamily: FONT_FAMILY.primaryV3,
                        WebkitLineClamp: 2,
                      },
                    ]}
                  >
                    {item?.label ?? ""}
                  </Text>
                );
              })
            ) : (
              <></>
            );

          return (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {status_display}
              {row?.jobList?.jobCardStatus?.[1]?.label?.toLowerCase() === "waiting for parts" && !isAquaEnabled() ? (
                <TouchableOpacity
                  style={{
                    width: 30,
                    height: 30,
                    marginStart: 5,
                    borderRadius: 15,
                    backgroundColor: "#6300A320",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onPress={() => {
                    setRefreshClick(true);
                    setCurrentRow(row);
                  }}
                >
                  <Ionicons name="refresh" size={15} color="#303030" />
                </TouchableOpacity>
              ) : null}
            </View>
          );
        },
        width: "9%",
      },
      {
        name: "POD Complexity",
        width: "1%",
        component: ({ row }) => {
          const activeJoblist = row?.getActiveJoblist;
          return (
            <TooltipV3 title={activeJoblist?.carComplexityForBayJoblist ?? "--"}>
              <Text>{activeJoblist?.carComplexityForBayJoblist ?? "--"}</Text>
            </TooltipV3>
          );
        },
      },
      {
        name: "Car Group",
        label: "carGroup",
        width: "15%",
        component: ({ row }: any) => {
          return (
            <View>
              <AppText numberOfLines={2} fontFamily='medium' fontSize={13} color={THEME_COLORS.coal}>{row?.workshopRefurbCarPodAndStatus?.groupName ?? "NA"}</AppText>
            </View>
          );
        },
      },
      {
        name: "POD Verifier",
        component: ({ row }: any) => {
          let {
            currentPodVerifierName,
            isPodVerifierAssignable,
            isPodVerifierReassignable,
            currentPodVerifierAssignedDatetime,
          } = row?.podVerifierData;
          const podVerifierName = currentPodVerifierName ?? currentPodVerifierName ?? "N/A";

          return (
            <View>
              <View style={styles.flexBox}>
                <TooltipV3 title={`${podVerifierName}`}>
                  <Text style={[styles.textWithIcon]} numberOfLines={1}>{`${podVerifierName}`}</Text>
                </TooltipV3>
                {(isPodVerifierAssignable || isPodVerifierReassignable) && (
                  <IconButton size="small" onClick={(ev) => onOpenVerifierListing(row, ev)}>
                    <EditIcon color="primary" fontSize="small" />
                  </IconButton>
                )}
              </View>
              <Text
                style={[
                  styles.status,
                  {
                    color: THEME_COLORS.textGrey,
                    fontFamily: FONT_FAMILY.semiBoldV3,
                  },
                ]}
              >
                {`${currentPodVerifierAssignedDatetime ? moment(currentPodVerifierAssignedDatetime).format("DD MMM 'YY hh:mmA") : "N/A"}`}
              </Text>
            </View>
          );
        },
        width: "12%",
      },
      {
        name: "Technician",
        component: ({ row }: any) => {
          const technicianDetails = row?.currentPodTechnicianNameAndAssignTime;
          const technicianName =
            cgtWorkshopMapping.current[row?.id]?.selectedST?.fullName ?? technicianDetails?.[0]?.label ?? "N/A";
          return (
            <View >
              <View style={styles.flexBox}>
                <TooltipV3 style={{display: 'flex', flex: 1}} title={`${technicianName}`}>
                  <Text style={[styles.textWithIcon,{flexShrink:1, maxWidth: '90%'}]} ellipsizeMode="tail" numberOfLines={2}>{`${technicianName}`}</Text>
                </TooltipV3>
                {row?.isTechnicianSuggestable && row?.technicianManualAssignment && !isAquaEnabled() ? (
                  <IconButton size="small" onClick={(ev) => onOpenSTListing(row, ev)}>
                    <EditIcon color="primary" fontSize="small" />
                  </IconButton>
                ) : null}
              </View>
              <Text
                style={[
                  styles.status,
                  {
                    color: THEME_COLORS.textGrey,
                    fontFamily: FONT_FAMILY.semiBoldV3,
                  },
                ]}
              >
                {`${technicianDetails?.[1]?.label ? moment(technicianDetails?.[1]?.label).format("DD MMM 'YY hh:mmA") : "N/A"}`}
              </Text>
            </View>
          );
        },
        width: "12%",
      },
      {
        name: "Lapsed/EST",
        label: "lapased",
        component: ({ row }: any) => {
          const isBreached=row?.jobListTatData?.actual>row?.jobListTatData?.estimated;
          if(!row?.jobListTatData?.actual || !row?.jobListTatData?.estimated){return(<View style={{alignItems:"center"}}><AppText fontFamily='medium' fontSize={14} color={THEME_COLORS.grey_55}>--</AppText></View>)}
          return (
            <View>
              {(isBreached) && <AppText fontFamily='bold' fontSize={14} color={THEME_COLORS.red}>{`Delayed by ${timeDifferenceInDayHrMin(row?.jobListTatData?.actual,row?.jobListTatData?.estimated)}`}</AppText>}
              <View style={styles.tatColumn}>
                <AppText fontFamily='medium' fontSize={isBreached ? 12 : 14} color={THEME_COLORS.coal}>{`${minFormator(row?.jobListTatData?.actual)} hrs `}</AppText>
                <AppText fontFamily='medium' fontSize={isBreached ? 12 : 14} color={THEME_COLORS.grey_55}>{` / ${minFormator(row?.jobListTatData?.estimated)} hrs`}</AppText>
              </View> 
            </View>
          );
        },
        // sortable: true,
        // onSort: () => {
        //   onClickSort("lapased_at");
        // },
        width: "10%",
      },
      {
        name: "Reason for hold",
        component: ({ row }) => {
          const canUnholdJoblist = row?.isJoblistUnholdableFromWorkshopDashboard;
          const jobListID = row?.getActiveJoblist?.id;
          const reason = row?.getActiveJoblist?.joblistOnHoldReason;

          return (
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <TooltipV3 title={reason ?? "--"}>
                <Text
                  style={{
                    maxWidth: 120,
                    flexShrink: 1,
                    fontFamily: FONT_FAMILY?.primaryV3,
                  }}
                  numberOfLines={1}
                >
                  {reason ?? "--"}
                </Text>
              </TooltipV3>
              {canUnholdJoblist ? (
                <TooltipV3 title={"Unhold"}>
                  <TouchableOpacity
                    style={{ marginStart: 5, opacity: unholdLoading ? 0.4 : 1 }}
                    disabled={unholdLoading}
                    onPress={() => {
                      unHoldJobListBtnSingleClick?.(jobListID);
                    }}
                  >
                    <FontAwesome name="unlock" size={25} color="#6300A3" />
                  </TouchableOpacity>
                </TooltipV3>
              ) : null}
            </View>
          );
        },
      },
      {
        name: "Status",
        align: "center",
        component: ({ row }: any) => {
          const statusExtractor = row?.isBayLayoutEnabled ? "jobCardStatus" : "sansPodJobCardStatus";
          const sliceIndex = row?.isBayLayoutEnabled ? 1 : 0;

          const status_display =
            isAquaEnabled() && row?.isBayLayoutEnabled ? (
              [
                <TooltipV3 title={row?.refurbCarWorkshopStatus ?? ""}>
                  <View
                    style={[
                      {
                        padding: 8,
                        height: 48,
                        backgroundColor: `${row?.jobList?.jobCardStatus?.[1]?.color}33`,
                        borderRadius: 5,
                        alignItems: "center",
                      },
                    ]}
                  >
                    <Text
                      style={[
                        styles.status,
                        {
                          color: row?.jobList?.jobCardStatus?.[1]?.color,
                          fontWeight: "bold",
                          margin: "auto",
                        },
                      ]}
                    >
                      {row?.refurbCarWorkshopStatus ?? ""}
                    </Text>
                  </View>
                </TooltipV3>,
              ]
            ) : Array.isArray(row?.jobList?.[statusExtractor]) ? (
              row?.jobList?.[statusExtractor]?.slice(sliceIndex).map((item, index) => {
                return (
                  <TooltipV3 title={item?.label ?? ""}>
                    <View
                      key={index.toString()}
                      style={[
                        {
                          padding: 8,
                          height: 48,
                          backgroundColor: `${item?.color}33`,
                          borderRadius: 5,
                          alignItems: "center",
                        },
                      ]}
                    >
                      <Text
                        style={[
                          styles.status,
                          {
                            color: item?.color,
                            fontWeight: "bold",
                            margin: "auto",
                          },
                        ]}
                      >
                        {item?.label ?? ""}
                      </Text>
                    </View>
                  </TooltipV3>
                );
              })
            ) : (
              <></>
            );
          return <View>{status_display}</View>;
        },
        rowColor: (row: any) => {
          const statusExtractor = row?.isBayLayoutEnabled ? "jobCardStatus" : "sansPodJobCardStatus";
          const sliceIndex = row?.isBayLayoutEnabled ? 1 : 0;

          return Array.isArray(row?.jobList?.[statusExtractor])
            ? row?.jobList?.[statusExtractor]?.slice(sliceIndex)?.[0]?.color
            : "#333";
        },
        width: "15%",
      },
    ].filter((_, idx) => idx !== 9 || isSpeedGaugeEnabled()),
    [cgtWorkshopMapping.current]
  );

  const loadMore = () => {
    const paginator = listData?.getRefurbCarListingV2?.paginator;

    if ((paginator && paginator.currentPage == paginator.numPages) || listLoading || loading) return;
    setLoading(true);
    fetchMore({
      variables: {
        page: paginator.currentPage + 1,
      },
    })
      .catch((err) => {
        setRetry(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getValue = (key: string) => {
    return filters.find((obj) => obj.key === key)?.value || "";
  };

  const fetchPODVerifierData = async (
    variables: any,
    apiCall: any,
    callback: (data: any) => void,
    err_callback: (error: any) => void
  ) => {
    try {
      const response = await apiCall?.({
        variables: {
          ...(variables ?? {}),
          workshopId: localStorage.getItem("workshopId"),
          refurbCarId: "17381",
        },
      });
      callback?.(response?.data?.getAllWorkshopPodVerifiers);
    } catch (e: any) {
      err_callback?.(e?.message ?? "Error: could not fetch POD verifier data");
      showAlert?.(e?.message ?? "Error: could not fetch POD verifier data", "error");
    }
  };

  const confirmAssignTechnician = useCallback(
    (row: any) => {
      setStSearch("");
      getWorkshopBay({
        variables: {
          workshopBayTypeId: row?.getActiveJoblist?.workshopBayType?.id,
        },
      })
        .then(({ data }) => {
          return assignTechnician({
            variables: {
              jobListId: row?.getActiveJoblist?.id,
              technicianId: selectedST?.id,
              workshopBayId: data?.getWorkshopBay?.[0]?.id,
            },
          });
        })
        .then((data) => {
          return refetchRefurbCarListingV2?.();
        })
        .then(() => {
          setAssignModal(null);
          setST(null);
          showAlert("Technician assigned successfully", "success");
        })
        .catch(() => {
          return refetchRefurbCarListingV2?.();
        });
    },
    [selectedST]
  );

  const confirmAssignPodVerifier = useCallback(
    (row: any) => {
      setPodVerifierSearch("");
      const dataToSend = {
        job_list_id: row?.getActiveJoblist?.id,
        pod_verifier_user_id: selectedVerifier?.userId,
      };
      const token = localStorage.getItem(REFURB_TOKEN);
      setAssignVerifierLoading(true);
      makePostApiRequest(
        `${HOST}/joblist/assign-pod-verifier`,
        JSON.stringify(dataToSend),
        {},
        "Keycloak-Authorization",
        "Bearer",
        "refurb"
      )
        .then((data) => {
          refetchRefurbCarListingV2?.();
          return data;
        })
        .then((resp) => {
          setPodVerifierModal(null);
          setSelectedVerifier(null);
          setAssignVerifierLoading(false);
          showAlert(resp?.data?.message, resp?.data?.success ? "success" : "error");
        })
        .catch((e) => {
          setAssignVerifierLoading(false);
          showAlert(e?.response?.data?.message, "error");
          return refetchRefurbCarListingV2?.();
        });
    },
    [selectedVerifier]
  );

  const closeRetryModal = () => {
    setRetry(false);
  };

  const onRowClick = (row) => {
    const { car } = row || {};

    navigation.navigate("JobCardScreen", {
      label: "Inventory Management",
      refurbCar: `${car?.year?.replace("A_", "") || ""}•${car?.make || ""}•${car?.model || ""} ${car?.variant || ""}•${
        car?.registrationNo
      }`,
      labelSt: JSON.stringify({ marginLeft: 20, fontSize: 15 }),
      refurbCarId: row.id,
      parent: "JobCardListingV3",
      isBayLayoutEnabled: row.isBayLayoutEnabled,
      isSparePartsServiceAvailable: row.isSparePartsServiceAvailable,
      // cancelable: true,
      requestSlug: row?.requestSlug,
      history: JSON.stringify(navigation.state),
      params: navigation.state?.params,
      jobListId: row?.jobList?.id
    });
  };

  const technicianResults = useMemo(() => {
    if (Array.isArray(technicianData?.getTechnicianUsersForCurrentPod)) {
      if (stSearch == "") return technicianData?.getTechnicianUsersForCurrentPod;
      return technicianData?.getTechnicianUsersForCurrentPod?.filter((stItem) =>
        stItem?.fullName?.toLowerCase().includes(stSearch)
      );
    } else return [];
  }, [stSearch, technicianData?.getTechnicianUsersForCurrentPod]);

  const podVerifierResults = useMemo(() => {
    const verifierList = podVerifierList?.data?.length > 0 ? [...podVerifierList?.data] : [];
    if (Array.isArray(verifierList)) {
      if (podVerifierSearch == "") return verifierList;
      return verifierList?.filter((verifierItem) => verifierItem?.fullName?.toLowerCase().includes(podVerifierSearch));
    } else return [];
  }, [podVerifierSearch, podVerifierList, podVerifierModal]);

  useEffect(() => {
    var params = {};
    filters.forEach((val) => {
      params[val?.key] = val?.value;
    });
    for (let i in navigation.state.params) {
      if (!!!params?.[i]) {
        params[i] = undefined;
      }
    }

    params["label"] = "Inventory";
    navigation.setParams(params);
  }, [filters]);

  useEffect(() => {
    const params = navigation.state.params;

    if (!!params) {
      const paramsMappedFilters = Object.keys(params)
        ?.filter((key) => key !== "label" && !!params?.[key])
        ?.map((key) => (
        key === "search" ? {
          key,
          value: params?.search,
        } : {
          key,
          value: Array?.isArray?.(params?.[key]) ? params?.[key] : [params?.[key]],
        }));
      setFilters(paramsMappedFilters);
      setSearch(params?.search ?? "");
      var filteredFilters = paramsMappedFilters ?? [];
      const onlyListFilterValues = filteredFilters?.filter?.((val) => Array?.isArray(val?.value));
      onlyListFilterValues?.forEach((val) => {
        filteredFilters = filteredFilters?.filter?.((v) => v?.value !== val?.value);
        val?.value?.forEach?.((v) => {
          filteredFilters?.push?.({ key: val?.key, value: v });
        });
      });
      getRefurbCarListingV2({ variables: { page, filters: filteredFilters, orderBy, search: params?.search } });
    }
  }, []);

  useEffect(() => {
    getFiltersForWorkshopDashboard?.();
  }, []);

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <View style={styles?.workTypeDropDownView}>
            <MultiSelectDropDownFilterV2
              dropDownWidth={200}
              defaultTitle="Work Type"
              setMiscModal={setMiscModal}
              data={
                workTypeFetchedFilters?.value?.map?.((val) => ({
                  id: val?.key,
                  title: val?.display_name,
                })) || []
              }
              selectedIndices={getValue(workTypeFetchedFilters?.key)?.map?.((val) =>
                workTypeFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
              )}
              selectedItem={workTypeFetchedFilters?.value
                ?.filter?.((val) => getValue(workTypeFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(workTypeFetchedFilters?.key)}
              onItemPress={(value) => {
                const selectedWorkTypes = getValue(workTypeFetchedFilters?.key);
                if (selectedWorkTypes?.includes?.(value)) {
                  changeFilter(
                    workTypeFetchedFilters?.key,
                    selectedWorkTypes?.filter?.((val) => val !== value)
                  );
                } else {
                  changeFilter(workTypeFetchedFilters?.key, [...selectedWorkTypes, value]);
                }
              }}
              onClearFilter={() => changeFilter(workTypeFetchedFilters?.key, [])}
            />
          </View>
          <View style={styles?.procCategoryDropDownView}>
            <MultiSelectDropDownFilterV2
              dropDownWidth={200}
              defaultTitle="Proc Category"
              setMiscModal={setMiscModal}
              data={
                procCatFetchedFilters?.value?.map?.((val) => ({
                  id: val?.key,
                  title: val?.display_name,
                })) || []
              }
              selectedIndices={getValue(procCatFetchedFilters?.key)?.map?.((val) =>
                procCatFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
              )}
              selectedItem={procCatFetchedFilters?.value
                ?.filter?.((val) => getValue(procCatFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(procCatFetchedFilters?.key)}
              onItemPress={(value) => {
                const selectedProcCategories = getValue(procCatFetchedFilters?.key);
                if (selectedProcCategories?.includes?.(value)) {
                  changeFilter(
                    procCatFetchedFilters?.key,
                    selectedProcCategories?.filter?.((val) => val !== value)
                  );
                } else {
                  changeFilter(procCatFetchedFilters?.key, [...selectedProcCategories, value]);
                }
              }}
              onClearFilter={() => changeFilter(procCatFetchedFilters?.key, [])}
            />
          </View>
          {!!podFetchedFilters?.value?.length ? (
            <View style={styles?.podDropDownView}>
              <MultiSelectDropDownFilterV2
                width={200}
                defaultTitle="POD"
                setMiscModal={setMiscModal}
                data={
                  podFetchedFilters?.value?.map?.((val) => ({
                    id: val?.key,
                    title: val?.display_name,
                  })) || []
                }
                selectedIndices={getValue(podFetchedFilters?.key)?.map?.((val) =>
                  podFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
                )}
                selectedItem={podFetchedFilters?.value
                  ?.filter?.((val) => getValue(podFetchedFilters?.key)?.includes?.(val?.key))
                  ?.map?.((val) => val?.display_name)
                  ?.join?.(", ")}
                canClearFilter={!!getValue(podFetchedFilters?.key)}
                onItemPress={(value) => {
                  const selectedPODs = getValue(podFetchedFilters?.key);
                  if (selectedPODs?.includes?.(value)) {
                    changeFilter(
                      podFetchedFilters?.key,
                      selectedPODs?.filter?.((val) => val !== value)
                    );
                  } else {
                    changeFilter(podFetchedFilters?.key, [...selectedPODs, value]);
                  }
                }}
                onClearFilter={() => changeFilter(podFetchedFilters?.key, [])}
              />
            </View>
          ) : null}
          {!(isAquaEnabled()) &&
          <View style={styles?.podVerifierDropDownView}>
            <MultiSelectDropDownFilterV2
              dropDownWidth={200}
              hasSearch={true}
              defaultTitle="Pod Verifier"
              setMiscModal={setMiscModal}
              data={
                podVerifierFetchedFilters?.value?.map?.((val) => ({
                  id: val?.key,
                  title: val?.display_name,
                })) || []
              }
              selectedIndices={getValue(podVerifierFetchedFilters?.key)?.map?.((val) =>
                podVerifierFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
              )}
              selectedItem={podVerifierFetchedFilters?.value
                ?.filter?.((val) => getValue(podVerifierFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(podVerifierFetchedFilters?.key)}
              onItemPress={(value) => {
                const selectedPODVerifiers = getValue(podVerifierFetchedFilters?.key);
                if (selectedPODVerifiers?.includes?.(value)) {
                  changeFilter(
                    podVerifierFetchedFilters?.key,
                    selectedPODVerifiers?.filter?.((val) => val !== value)
                  );
                } else {
                  changeFilter(podVerifierFetchedFilters?.key, [...selectedPODVerifiers, value]);
                }
              }}
              onClearFilter={() => changeFilter(podVerifierFetchedFilters?.key, [])}
            />
          </View>}
          {isAquaEnabled() && 
          <View style={styles?.podVerifierDropDownView}>
            <MultiSelectDropDownFilterV2
              dropDownWidth={200}
              hasSearch={true}
              defaultTitle="Car Group"
              setMiscModal={setMiscModal}
              data={
                carGroupFetchedFilters?.value?.map?.((val) => ({
                  id: val?.key,
                  title: val?.display_name,
                })) || []
              }
              selectedIndices={getValue(carGroupFetchedFilters?.key)?.map?.((val) =>
                carGroupFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
              )}
              selectedItem={carGroupFetchedFilters?.value
                ?.filter?.((val) => getValue(carGroupFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(carGroupFetchedFilters?.key)}
              onItemPress={(value) => {
                const selectedCarGroup = getValue(carGroupFetchedFilters?.key);
                if (selectedCarGroup?.includes?.(value)) {
                  changeFilter(
                    carGroupFetchedFilters?.key,
                    selectedCarGroup?.filter?.((val) => val !== value)
                  );
                } else {
                  changeFilter(carGroupFetchedFilters?.key, [...selectedCarGroup, value]);
                }
              }}
              onClearFilter={() => changeFilter(carGroupFetchedFilters?.key, [])}
            />
          </View>}
          <View style={styles?.technicianDropDownView}>
            <MultiSelectDropDownFilterV2
              dropDownWidth={200}
              hasSearch={true}
              defaultTitle="Technician"
              setMiscModal={setMiscModal}
              data={
                technicianFetchedFilters?.value?.map?.((val) => ({
                  id: val?.key,
                  title: val?.display_name,
                })) || []
              }
              selectedIndices={getValue(technicianFetchedFilters?.key)?.map?.((val) =>
                technicianFetchedFilters?.value?.findIndex?.((v) => v?.key === val)
              )}
              selectedItem={technicianFetchedFilters?.value
                ?.filter?.((val) => getValue(technicianFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(technicianFetchedFilters?.key)}
              onItemPress={(value) => {
                const selectedTechnicians = getValue(technicianFetchedFilters?.key);
                if (selectedTechnicians?.includes?.(value)) {
                  changeFilter(
                    technicianFetchedFilters?.key,
                    selectedTechnicians?.filter?.((val) => val !== value)
                  );
                } else {
                  changeFilter(technicianFetchedFilters?.key, [...selectedTechnicians, value]);
                }
              }}
              onClearFilter={() => changeFilter(technicianFetchedFilters?.key, [])}
            />
          </View>
          <View style={styles?.statusDropDownView}>
            <MultiSelectNestedDropDown
              dropDownWidth={300}
              defaultTitle="Status"
              setMiscModal={setMiscModal}
              data={statusFetchedFilters?.value?.map((val) => ({
                id: val?.key,
                name: val?.display_name,
                children: val?.nested_filters?.map?.((v) => ({
                  id: v?.key,
                  name: v?.display_name,
                  children: null,
                })),
              }))}
              selectedIds={getValue(statusFetchedFilters?.key)}
              selectedItem={statusFetchedFilters?.value
                ?.filter?.((val) => getValue(statusFetchedFilters?.key)?.includes?.(val?.key))
                ?.map?.((val) => val?.display_name)
                ?.join?.(", ")}
              canClearFilter={!!getValue(statusFetchedFilters?.key)}
              onItemPress={(value) => {
                // changeFilter(statusFetchedFilters?.key, value?.id)
                const selectedStatuses = getValue(statusFetchedFilters?.key);
                if (selectedStatuses?.includes?.(value?.id)) {
                  changeFilter(
                    statusFetchedFilters?.key,
                    selectedStatuses?.filter?.((val) => val !== value?.id)
                  );
                } else {
                  changeFilter(statusFetchedFilters?.key, [...selectedStatuses, value?.id]);
                }
                setMiscModal(false, { x: -1, y: -1 }, null);
              }}
              onClearFilter={() => changeFilter(statusFetchedFilters?.key, "")}
            />
          </View>
          {!!remainingPodFilters?.value?.length ? (
            <View style={styles?.podDropDownView}>
              <MultiSelectDropDownFilterV2
                dropDownWidth={220}
                defaultTitle="Remaining PODs Name"
                setMiscModal={setMiscModal}
                data={
                  remainingPodFilters?.value?.map?.((val) => ({
                    id: val?.key,
                    title: val?.display_name,
                  })) || []
                }
                selectedIndices={getValue(remainingPodFilters?.key)?.map?.((val) =>
                  remainingPodFilters?.value?.findIndex?.((v) => v?.key === val)
                )}
                selectedItem={remainingPodFilters?.value
                  ?.filter?.((val) => getValue(remainingPodFilters?.key)?.includes?.(val?.key))
                  ?.map?.((val) => val?.display_name)
                  ?.join?.(", ")}
                canClearFilter={!!getValue(remainingPodFilters?.key)}
                onItemPress={(value) => {
                  const selectedPODs = getValue(remainingPodFilters?.key);
                  if (selectedPODs?.includes?.(value)) {
                    changeFilter(
                      remainingPodFilters?.key,
                      selectedPODs?.filter?.((val) => val !== value)
                    );
                  } else {
                    changeFilter(remainingPodFilters?.key, [...selectedPODs, value]);
                  }
                }}
                onClearFilter={() => changeFilter(remainingPodFilters?.key, [])}
              />
            </View>
          ) : null}
          {!!remainingPodCountFilters?.value?.length ? (
            <View style={styles?.podDropDownView}>
              <MultiSelectDropDownFilterV2
                dropDownWidth={220}
                defaultTitle="Remaining PODs Count"
                setMiscModal={setMiscModal}
                data={
                  remainingPodCountFilters?.value?.map?.((val) => ({
                    id: val?.key,
                    title: val?.display_name,
                  })) || []
                }
                selectedIndices={getValue(remainingPodCountFilters?.key)?.map?.((val) =>
                  remainingPodCountFilters?.value?.findIndex?.((v) => v?.key === val)
                )}
                selectedItem={remainingPodCountFilters?.value
                  ?.filter?.((val) => getValue(remainingPodCountFilters?.key)?.includes?.(val?.key))
                  ?.map?.((val) => val?.display_name)
                  ?.join?.(", ")}
                canClearFilter={!!getValue(remainingPodCountFilters?.key)}
                onItemPress={(value) => {
                  const selectedPODs = getValue(remainingPodCountFilters?.key);
                  if (selectedPODs?.includes?.(value)) {
                    changeFilter(
                      remainingPodCountFilters?.key,
                      selectedPODs?.filter?.((val) => val !== value)
                    );
                  } else {
                    changeFilter(remainingPodCountFilters?.key, [...selectedPODs, value]);
                  }
                }}
                onClearFilter={() => changeFilter(remainingPodCountFilters?.key, [])}
              />
            </View>
          ) : null}
            {isSpeedGaugeEnabled() && !!breachedTatToggle && <TouchableOpacity
              disabled={listLoading}
              style={[
                styles.filterCon,
                  {
                    backgroundColor: breachedTat === true && THEME_COLORS.purple,
                    opacity: false ? 0.6 : 1,
                  },
                    ]}
                  onPress={()=>{
                    setBreachedTat(!breachedTat)
                    changeToggleFilter(breachedTatToggle?.key,"true")
                  }}
                  >
                  <AppText
                      fontSize={14}
                      fontFamily="medium"
                      style={{
                        color: breachedTat === true ? "#FFFFFF" : "#303030",
                      }}
                      >
                    {breachedTatToggle?.display_name}
                  </AppText>
            </TouchableOpacity>}
        </View>
      </View>

      <Divider color={THEME_COLORS.sideMenuBg} width={4} style={{ marginVertical: "1em" }} />
      <Text
        style={{
          color: THEME_COLORS.sideMenuGrey,
          fontFamily: "NotoSans",
          marginRight: 20,
        }}
      >
        Total Cars :{" "}
        <Text
          style={{
            fontFamily: "NotoSansBold",
            color: THEME_COLORS.black,
            marginRight: 20,
          }}
        >
          {listData?.getRefurbCarListingV2?.paginator?.totalItems ?? "--"}
        </Text>
      </Text>

      <InventoryTable
        columnData={columnData?.filter((columnData)=>{
          if(isAquaEnabled()){
            return columnData?.name !== "CGT" && columnData?.name !== "POD Verifier" && columnData?.name !== 'POD Complexity'
          }
          else{
            return columnData?.name !== "Car Group"
          }
        })}
        data={listData?.getRefurbCarListingV2}
        loading={listLoading || loading}
        page={page}
        totalPages={listData?.getRefurbCarListingV2?.paginator?.numPages || 0}
        cgtSelected={selectedST}
        onRowClick={onRowClick}
        rowProps={{ clickable: true }}
        loadMore={loadMore}
      />

      {podVerifierModal && Object.keys(podVerifierModal)?.length > 0 ? (
        <PodAssignmentModal
          visible={podVerifierModal}
          canLoadMorePages={podVerifierList?.paginator?.currentPage < podVerifierList?.paginator?.numPages}
          onEndReached={getPodVerifierPagination}
          listToRender={podVerifierResults}
          toggleModal={(val) => setPodVerifierModal(val)}
          podVerifierSearch={podVerifierSearch}
          setPodVerifierSearch={setPodVerifierSearch}
          onConfirm={() => confirmAssignPodVerifier(podVerifierModal)}
          selectedVerifier={selectedVerifier}
          setSelectedVerifier={setSelectedVerifier}
          disabledConfirm={
            !selectedVerifier ||
            selectedVerifier?.fullName == podVerifierModal?.podVerifierData?.currentPodVerifierName ||
            verifierAssignLoading ||
            listLoading
          }
          listLoading={verifierInitialLoading}
        />
      ) : null}

      <ModalV3
        visible={assignmentModal}
        header={
          technicianResults.length > 1 && assignmentModal?.currentPodTechnicianNameAndAssignTime?.[0]?.label
            ? "Technician Re-Assignment"
            : "Technician Assignment"
        }
        subheader={"Please select the technician"}
        onCancel={() => {
          setAssignModal(null);
          setStSearch("");
        }}
        onConfirm={() => confirmAssignTechnician(assignmentModal)}
        confirmButtonText={
          technicianResults.length > 1 && assignmentModal?.currentPodTechnicianNameAndAssignTime?.[0]?.label
            ? "Re-assign Technician"
            : "Assign Technician"
        }
        disabledConfirm={
          !selectedST ||
          selectedST?.fullName == assignmentModal?.currentPodTechnicianNameAndAssignTime?.[0]?.label ||
          loadingAssignment ||
          listLoading
        }
      >
        <SearchBar
          placeholder={"Search with Technician...."}
          onChangeText={setStSearch}
          value={stSearch}
          inputContainerStyle={styles.modalSearch}
          inputStyle={{ outline: "none", fontSize: 15 }}
          cancelButtonTitle=""
          cancelButtonProps={{ buttonStyle: { width: 8 } }}
        />

        {techniciansLoading ? (
          <View style={[styles.flexBox, { justifyContent: "center" }]}>
            <ActivityIndicator size="large" color={THEME_COLORS.purple} />
          </View>
        ) : (
          <STListing
            data={technicianResults}
            selected={selectedST}
            onSelect={setST}
            suggested={assignmentModal?.currentPodTechnicianNameAndAssignTime?.[0]?.label}
          />
        )}
      </ModalV3>
      <Snackbar open={retry} autoHideDuration={6000} onClose={closeRetryModal}>
        <Alert severity="warning" action={<Button title="Retry" type="clear" titleStyle={styles.retryButton} />}>
          Failed to more list!
        </Alert>
      </Snackbar>
      {purchaserState.miscModal.visibility ? (
        <MiscellaneousModal
          modalVisibility={purchaserState.miscModal.visibility}
          onClose={() => {
            setMiscModal(false, { x: -1, y: -1 }, null);
          }}
        />
      ) : null}
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: "1.2em",
  },
  inputContainer: {
    backgroundColor: THEME_COLORS.grey2,
    width: "30vw",
    padding: 0,
  },
  modalSearch: {
    backgroundColor: "transparent",
  },
  flexBox: { flexDirection: "row", alignItems: "center" },
  button: {
    paddingHorizontal: "1em",
    paddingVertical: "0.6em",
    backgroundColor: THEME_COLORS.purple2,
    width: "fit-content",
    minWidth: 150,
  },
  buttonTitle: {
    fontSize: 14,
    fontFamily: FONT_FAMILY.mediumV3,
  },
  workLeadId: {
    fontSize: 14,
    fontFamily: FONT_FAMILY.primaryV3,
  },
  status: {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 1,
    fontSize: "1em",
    fontFamily: FONT_FAMILY.boldV3,
  },
  textWithIcon: {
    fontSize: "1em",
    fontFamily: FONT_FAMILY.boldV3,
    maxWidth: "82%",
    marginRight: 4,
  },
  statusDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  technicianDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  podVerifierDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  procCategoryDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  podDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  workTypeDropDownView: {
    marginTop: 15,
    marginHorizontal: 10,
  },
  filterCon: {
    marginTop:15,
    paddingVertical: 7,
    paddingHorizontal: 20,
    borderRadius: 20,
    borderWidth: 1,
    borderColor: '#6300A333',
  },
  tatColumn:{
    flexDirection:'row',
    flexWrap:'wrap',
    flex:1
  }
});

export default JobCardListing;
